<mat-spinner color="accent" [diameter]="diameter"></mat-spinner>
